export default __webpack_public_path__ + "static/media/LINK.e.3889d378.png";